module.exports = __webpack_public_path__ + "img/Server2.eeaeabf.svg";